import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CarriersToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function CarriersToolbar({ canManage, onCreate }: CarriersToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຜູ້ໃຫ້ບໍລິການຂົນສົ່ງ</h2>
          <p className="text-muted-foreground">ຈັດການຜູ້ຂົນສົ່ງທີ່ລູກຄ້າເລືອກໄດ້ຕອນກອກທີ່ຢູ່</p>
        </div>
        <div className="flex items-center gap-2">
          {canManage && (
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງຜູ້ຂົນສົ່ງ
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
